import { useEffect, useMemo, useRef, useState } from "react";
import { envChangeType } from "../../../../../../plugins/utils";
import GameItem from "../GameItem";
import styles from "./style.module.scss";

const JACKPOT_UPDATE_INTERVAL = 5000;
const JACKPOT_MIN_INCREMENT = 100;
const JACKPOT_MAX_INCREMENT = 10000;

const getRandomNumber = (min, max) => Math.random() * (max - min) + min;
const getRandomInteger = (min, max) => Math.floor(getRandomNumber(min, max + 1));
const toCents = (amount) => Math.round(amount * 100);
const formatJackpotValue = (valueInCents) =>
  (valueInCents / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const generateInitialJackpot = () => {
  const integerPart = Number(
    `4${getRandomInteger(0, 9)}${getRandomInteger(0, 9)}${getRandomInteger(0, 9)}${getRandomInteger(
      0,
      9,
    )}${getRandomInteger(0, 9)}${getRandomInteger(0, 9)}${getRandomInteger(0, 9)}${getRandomInteger(
      0,
      9,
    )}`,
  );
  return toCents(integerPart + getRandomInteger(0, 99) / 100);
};

const JackpotContainer = ({
  hotList = [],
  gameItemImageContainerStyle = "",
  gameBadgeStyle = "",
  gameNameStyle = "",
  maintainImageStyle = "",
  gameRecentStyle = "",
  gameItemPlatformStyle = "",
}) => {
  const productionName = envChangeType("REACT_APP_PRODUCTION_NAME_DEV");
  const [jackpotValueInCents, setJackpotValueInCents] = useState(() => generateInitialJackpot());
  const previousJackpotCharsRef = useRef([]);

  useEffect(() => {
    const timer = setInterval(() => {
      const randomIncrement = toCents(
        getRandomNumber(JACKPOT_MIN_INCREMENT, JACKPOT_MAX_INCREMENT),
      );
      setJackpotValueInCents((prev) => prev + randomIncrement);
    }, JACKPOT_UPDATE_INTERVAL);

    return () => clearInterval(timer);
  }, []);

  const jackpotText = useMemo(() => formatJackpotValue(jackpotValueInCents), [jackpotValueInCents]);
  const jackpotCells = useMemo(() => {
    const currentChars = jackpotText.split("");
    const previousChars = previousJackpotCharsRef.current;

    return currentChars.map((char, index) => {
      const isDigit = /[0-9]/.test(char);
      const hasPrevious = previousChars[index] !== undefined;
      return {
        char,
        isDigit,
        digitValue: isDigit ? Number(char) : null,
        hasChanged: isDigit && hasPrevious && previousChars[index] !== char,
      };
    });
  }, [jackpotText]);

  useEffect(() => {
    previousJackpotCharsRef.current = jackpotText.split("");
  }, [jackpotText]);

  return (
    <div className={styles.jackpotContainer}>
      <img
        className={styles.jackpotBannerImage}
        src={`/images/logo/${productionName}/jackpot_top.png`}
        alt="jackpot banner"
      />
      <div className={styles.jackpotValue}>
        {jackpotCells.map(({ char, isDigit, hasChanged, digitValue }, index) => (
          <span
            key={`jackpot-cell-${index}`}
            className={`${styles.jackpotDigitSlot} ${
              isDigit ? styles.jackpotDigitSlotNumber : styles.jackpotDigitSlotSeparator
            }`}
          >
            {isDigit ? (
              <span
                className={`${styles.jackpotDigitTrack} ${
                  hasChanged ? styles.jackpotDigitTrackAnimating : ""
                }`}
                style={{ transform: `translateY(-${digitValue * 10}%)` }}
              >
                {Array.from({ length: 10 }, (_, value) => (
                  <span key={`jackpot-digit-${index}-${value}`} className={styles.jackpotDigit}>
                    {value}
                  </span>
                ))}
              </span>
            ) : (
              <span className={styles.jackpotDigit}>{char}</span>
            )}
          </span>
        ))}
      </div>
      <div className={styles.jackpotBottomHotList}>
        {hotList.map((hot, index) => (
          <div key={`bottom_hot_${hot.game_code}${index}`} className={styles.jackpotBottomHotItem}>
            <GameItem
              key={hot.game_code}
              game={hot}
              gameItemImageContainerStyle={gameItemImageContainerStyle}
              gameNameStyle={gameNameStyle}
              gameBadgeStyle={gameBadgeStyle}
              maintainImageStyle={maintainImageStyle}
              gameRecentStyle={gameRecentStyle}
              gameItemPlatformStyle={gameItemPlatformStyle}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default JackpotContainer;
